// fragmentUrl.js
//
// Where a fragment GLB actually lives, given the relative url a tile
// sidecar names it by.
//
// In its own module, free of three.js, for the same reason
// webgl/.../fragmentBase.js is: url logic is the part that silently
// breaks everything downstream, so it has to be testable without
// dragging an ESM loader through a transform that is not configured for
// node_modules.
//
// TWO RULES, and getting either wrong fails quietly rather than loudly:
//
// 1. `.gz` is mandatory. The sidecar names the fragment without it
//    ("fragments/Doors_...glb"), R2 stores it WITH it and serves it
//    under Content-Encoding: gzip, and GLBFetcher.buildUrl appends it.
//    The backend's /uploads handler forwards to R2 only for paths ending
//    in `.gz`, so a request for the bare .glb does not 404 - it falls
//    through to the SPA catch-all and returns index.html with status
//    200. GLTFLoader then chokes on HTML, and every fragment renders
//    nothing with nothing in the network tab that looks like a failure.
//
// 2. Anything under `fragments/` is GLOBAL and sits at the bucket root;
//    everything else is relative to the manifest that named it. Fragments
//    are content-addressed and shared across projects, which is what
//    makes an old generation's shape recoverable long after its own
//    export was overwritten.
import { url as apiUrl } from "api";

export function resolveFragmentUrl(rel, manifestKey) {
  const clean = String(rel || "").replace(/^\/+/, "");
  if (!clean) return "";
  const withGz = /\.gz$/i.test(clean) ? clean : `${clean}.gz`;
  if (/^fragments\//i.test(withGz)) return `${apiUrl}/uploads/${withGz}`;
  const dir = String(manifestKey || "").replace(/^uploads\//, "").replace(/\/[^/]*$/, "");
  return `${apiUrl}/uploads/${dir ? `${dir}/` : ""}${withGz}`;
}

export default resolveFragmentUrl;
